import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbList,
    BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import useMatchedBreadcrumbs from './hooks/useMatchedBreadcrumbs';
import { BreadcrumbContainer } from './styled';

const AppBreadcrumb = () => {
    const breadcrumbConfigs = useMatchedBreadcrumbs();

    if (!breadcrumbConfigs || breadcrumbConfigs.length === 0) {
        return null;
    }

    return (
        <BreadcrumbContainer>
            <Breadcrumb>
                <BreadcrumbList>
                    {breadcrumbConfigs
                        .map((config, index) => {
                            const Component = config.component;
                            return [
                                <BreadcrumbItem key={`item-${index}`}>
                                    <Component {...(config.props || {})} />
                                </BreadcrumbItem>,
                                ...(index < breadcrumbConfigs.length - 1
                                    ? [<BreadcrumbSeparator key={`sep-${index}`} />]
                                    : []),
                            ];
                        })
                        .flat()}
                </BreadcrumbList>
            </Breadcrumb>
        </BreadcrumbContainer>
    );
};

export default AppBreadcrumb;
